import * as React from 'react';
import type { SVGProps } from 'react';
const SvgItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 4.75h-2.25m2.25 0h2.25m-2.25 0-4 14.5m0 0H7.75m2.25 0h2.25"
    />
  </svg>
);
export default SvgItalic;
